module.exports = __webpack_public_path__ + "static/media/guia_aspirante.5a45c8da.pdf";